import axios from 'axios';

import { Helpers } from '../helpers';
import { ProductAPI } from "./product"
import { ProductGroupAPI } from "./product-group"
import { PageAPI } from "./page";
import { GraphQLAPI } from './graphql';
import { ComponentAPI } from "./component";
import { LogAPI } from './logger';
import { SwiftypeAPI } from "./swiftype";
import ServerAPI from './server-api';

const apiGatewayConfig = {
  maxPageSize: 25,
  base: process.env.API_GATEWAY_BASE || 'stage',
  domain: process.env.API_GATEWAY_SERVER,
};

export const StoreAppAPI = function () {
  const hostMap = {
    "glbecom-edit-web.austin.hp.com": "//www.hpstoreapp.com",
    "store.hp.com": "//store.hp.com",
    "uat.store.hp.com": "//uat.store.hp.com",
    "uat2.store.hp.com": "//uat2.store.hp.com",
    "localhost": "http://localhost:5000",
    "root": "/",
    "stage": "//stage.hpstoreapp.com",
    "production": "//store.hp.com"
  };
  let self = this;

  let currHost
  if (process.env.ISNODE) {
    currHost = process.env.ENV;
  } else {
    currHost = document.location.hostname;
  }

  let config = {};
  let apiInstance;
  if (process.env.ISNODE) {
    apiInstance = new ServerAPI()
  } else {
    apiInstance = axios.create({ baseURL: hostMap[currHost || 'root'] });

    //pass along pStoreID to all api calls
    apiInstance.interceptors.request.use((httpConfig) => {
      try {
        const { pStoreID, _preview } = Helpers.getSearch(window.location.search)
        httpConfig.params = httpConfig.params || {};
        if (pStoreID) {
          httpConfig.params.pStoreID = pStoreID
        }
        if (_preview) {
          httpConfig.params._preview = _preview
        }
      } catch (e) { }
      return httpConfig;
    });
  }
  const apiGatewayInstance = axios.create({
    baseURL: `https://${apiGatewayConfig.domain}/${apiGatewayConfig.base}`
  });
  self.component = new ComponentAPI(config, apiInstance, Helpers)
  self.product = new ProductAPI(config, apiInstance, Helpers);
  self.productGroup = new ProductGroupAPI(config, apiInstance, Helpers);
  self.page = new PageAPI(config, apiInstance, Helpers);
  self.graphql = new GraphQLAPI(config, apiInstance, Helpers);
  self.swiftype = new SwiftypeAPI(config, apiInstance, Helpers);
  self.logger = new LogAPI(apiGatewayConfig, apiGatewayInstance, Helpers);
}
